import { Seo } from "@/components/Seo";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
  noIndex?: boolean;
  schemaJson?: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Centralised SEO <head> component.
 * Thin wrapper over <Seo /> which owns canonical/OG/Twitter/robots output
 * and always builds URLs from the hardcoded SITE_URL constant.
 */
export function SEOHead({
  title,
  description,
  canonical,
  ogImage,
  noIndex = false,
  schemaJson,
}: SEOHeadProps) {
  return (
    <Seo
      title={title}
      description={description}
      canonicalPath={canonical}
      ogImage={ogImage}
      noIndex={noIndex}
      schema={schemaJson}
    />
  );
}
